<template>
    <div>
        <div
            class="w-50 d-flex align-items-center justify-content-center select-provider-btn"
            @click="isProviderDialogOpened = true"
        >
            <p class="mb-0 px-2 text-center">{{ selectedProviderName || 'Select' }}</p>
            <van-icon
                style="transform: rotate(90deg);"
                name="play"
                size="16px"
            />
        </div>

        <van-dialog
            v-model:show="isProviderDialogOpened"
            title="Search"
            :showConfirmButton="false"
            class="games-search-dialog"
        >
            <template #title>
                <div class="position-relative p-0">
                    <h3 class="m-0 text-white">Select Provider</h3>
                    <button
                        class="close-btn"
                        @click="isProviderDialogOpened = false"
                    >
                        <van-icon
                            name="close"
                            size="20px"
                            color="#fff"
                        />
                    </button>
                </div>
            </template>

            <div class="container-fluid my-4">
                <div class="row m-0">
                    <div
                        v-for="(provider, index) in providers"
                        :key="index"
                        @click="changeProvider(provider.code)"
                        class="col-12 py-2 px-4 mb-3 provider-item"
                        :class="{ active: provider.code === $route.query.provider }"
                    >
                        <p class="mb-0 font-weight-bold">{{ provider.name }}</p>
                    </div>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
export default {
    props: {
        providers: {
            type: Array,
            required: true,
        },
        selectedProvider: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isProviderDialogOpened: false,
        };
    },
    computed: {
        selectedProviderName() {
            if (!this.selectedProvider) return ''

            const found = this.providers.find(
                p => p.code === this.selectedProvider
            )

            // If not found, return the raw code
            return found ? found.name : this.selectedProvider
        },
    },
    methods: {
        changeProvider(providerCode) {
            if (this.$route.query.provider === providerCode) {
                this.isProviderDialogOpened = false;
            } else {
                this.isProviderDialogOpened = false;
                this.$router.push({
                    query: { ...this.$route.query, provider: providerCode },
                });
            }
        },
    },
};
</script>

<style scoped>
.games-search-dialog {
    width: 100% !important;
    height: 100vh;
    inset: 0 !important;
    border-radius: 0;
    overflow-y: auto;
    transform: translate(0, 0);
    scrollbar-width: none;
    background: #3f1387;

    h3 {
        font-size: 1.2rem;
    }

    .close-btn {
        position: absolute;
        top: 0;
        right: 10px;
        background: transparent;
        border: none;
        cursor: pointer;
    }
}

.select-provider-btn {
    cursor: pointer;
    color: #fff;
    transition: background 0.3s;
}

.provider-item {
    background: #5c2eb8;
    border-radius: 6px;
    color: #fff;
    transition: all 0.3s ease;
    cursor: pointer;
}

.provider-item:hover {
    background: #6d3bd9;
}

.provider-item.active {
    background: #a78bfa;
    color: #1e0f3f;
}
</style>
